export const pathnames: Record<string, Record<string, string>> = {
  "/": {
    "en": "/",
    "fr": "/",
    "lastmod": "2026-03-09T00:00:00.000Z"
  },
  "/freetools/site-checker": {
    "en": "/freetools/pimms-tracking-site-checker-install",
    "fr": "/freetools/pimms-tracking-site-checker-installation",
    "lastmod": "2026-03-09T00:00:00.000Z"
  },
  "/articles": {
    "en": "/articles",
    "fr": "/articles",
    "lastmod": "2026-03-09T00:00:00.000Z"
  },
  "/articles/category/digital-marketing": {
    "en": "/blog/marketing",
    "fr": "/blog/marketing",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/category/legal": {
    "en": "/legal",
    "fr": "/legal",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/author/alexandre": {
    "en": "/articles/author/alexandre",
    "fr": "/articles/auteur/alexandre",
    "lastmod": "2026-03-09T00:00:00.000Z"
  },
  "/articles/author/emma": {
    "en": "/articles/author/emma",
    "fr": "/articles/auteur/emma",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/category/guides": {
    "en": "/guides",
    "fr": "/guides",
    "lastmod": "2026-03-09T00:00:00.000Z"
  },
  "/articles/category/tutorials": {
    "en": "/tutorials",
    "fr": "/tutoriels",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/category/tool-comparison": {
    "en": "/tools",
    "fr": "/outils",
    "lastmod": "2026-02-21T00:00:00.000Z"
  },
  "/articles/5-dynamic-link-personalization-tips-for-higher-conversions": {
    "en": "/blog/5-dynamic-link-personalization-tips-for-higher-conversions",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/5-conseils-de-personnalisation-dynamique-des-liens-pour-augmenter-tes-conversions"
  },
  "/articles/5-funnel-tracking-errors-that-skew-data": {
    "en": "/blog/5-funnel-tracking-errors-that-skew-data",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/5-erreurs-de-tracking-de-funnel-qui-faussent-tes-donnees"
  },
  "/articles/7-ways-to-boost-mobile-app-conversion-rates-in-2025": {
    "en": "/blog/7-ways-to-boost-mobile-app-conversion-rates-in-2025",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/7-moyens-pour-booster-les-conversions-des-apps-mobiles-en-2025"
  },
  "/articles/a-b-testing-for-smart-links-step-by-step-guide": {
    "en": "/blog/a-b-testing-for-smart-links-step-by-step-guide",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/a-comprehensive-guide-to-essential-vibe-coding-tools": {
    "en": "/blog/a-comprehensive-guide-to-essential-vibe-coding-tools",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/ab-testing-for-agencies-how-to-deliver-results-to-clients": {
    "en": "/blog/ab-testing-for-agencies-how-to-deliver-results-to-clients",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/ab-testing-for-startups-with-low-traffic-strategies-that-work": {
    "en": "/blog/ab-testing-for-startups-with-low-traffic-strategies-that-work",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/ab-testing-steps-for-funnel-optimization": {
    "en": "/blog/ab-testing-steps-for-funnel-optimization",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/ab-testing-pour-optimiser-son-tunnel-de-conversion"
  },
  "/articles/affiliate-revenue-tracking-with-utm-parameters": {
    "en": "/blog/affiliate-revenue-tracking-with-utm-parameters",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/ai-powered-marketing-attribution-what-you-need-to-know": {
    "en": "/blog/ai-powered-marketing-attribution-what-you-need-to-know",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/best-10-url-shorteners-for-link-management-tracking": {
    "en": "/blog/best-10-url-shorteners-for-link-management-tracking",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/best-ab-testing-tools-2025-edition": {
    "en": "/blog/best-ab-testing-tools-2025-edition",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/bitly-vs-pimms-what-founders-really-need-beyond-click-tracking": {
    "en": "/blog/bitly-vs-pimms-what-founders-really-need-beyond-click-tracking",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/bitly-vs-pimms-ce-qu-une-startup-a-vraiment-besoin-au-dela-du-suivi-des-clics"
  },
  "/articles/blink-vs-pimms-comparison-2026": {
    "en": "/blog/blink-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/branded-short-links-vs-generic-does-it-impact-your-conversion-rate": {
    "en": "/blog/branded-short-links-vs-generic-does-it-impact-your-conversion-rate",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/build-fast-build-smart-using-apis-for-mvps-and-analytics": {
    "en": "/blog/build-fast-build-smart-using-apis-for-mvps-and-analytics",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/can-i-track-deep-links-and-conversions-without-using-an-sdk": {
    "en": "/blog/can-i-track-deep-links-and-conversions-without-using-an-sdk",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/can-you-test-more-than-one-change-at-a-time-and-other-ab-testing-faqs": {
    "en": "/blog/can-you-test-more-than-one-change-at-a-time-and-other-ab-testing-faqs",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/common-utm-tracking-mistakes-how-to-fix": {
    "en": "/blog/common-utm-tracking-mistakes-how-to-fix",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/cuttly-vs-pimms-comparison-2026": {
    "en": "/blog/cuttly-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/deep-linking-for-influencer-campaigns-basics": {
    "en": "/blog/deep-linking-for-influencer-campaigns-basics",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/les-bases-du-marketing-influence-avec-deep-linking"
  },
  "/articles/deep-links-vs-universal-links-whats-the-difference": {
    "en": "/blog/deep-links-vs-universal-links-whats-the-difference",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/deep-links-vs-universal-links-quelle-est-la-difference"
  },
  "/articles/dubco-alternatives-comparison-2025": {
    "en": "/blog/dubco-alternatives-comparison-2025",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/first-article": {
    "en": "/blog/what-is-pimms",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/from-first-click-to-conversion-understand-exactly-how-your-marketing-drives-revenue": {
    "en": "/blog/from-first-click-to-conversion-how-your-marketing-drives-revenue",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comprends-comment-ton-marketing-genere-du-chiffre-d-affaires"
  },
  "/articles/glossary-utms-tracking-attribution-conversions-deep-links-essential-terms-explained": {
    "en": "/blog/glossary-utms-tracking-attribution-conversions-deep-links",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/glossaire-utms-tracking-attribution-conversions-deep-links"
  },
  "/articles/gradual-rollouts-how-to-ab-test-with-90-10-traffic-splits-to-mitigate-risk": {
    "en": "/blog/gradual-rollouts-how-to-ab-test-with-90-10-traffic-splits-to-mitigate-risk",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-a-solo-founder-tracks-stripe-sales-from-twitter-linkedin-and-product-hunt": {
    "en": "/blog/how-a-solo-founder-tracks-stripe-sales-from-twitter-linkedin-and-product-hunt",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-deep-links-improve-conversion-paths": {
    "en": "/blog/how-deep-links-improve-conversion-paths",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-les-deep-links-ameliorent-les-parcours-de-conversion"
  },
  "/articles/how-do-i-add-analytics-to-an-ai-generated-app-or-prompt-based-build": {
    "en": "/blog/how-do-i-add-analytics-to-an-ai-generated-app-or-prompt-based-build",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-ajouter-des-analytics-a-une-app-ia-ou-construite-par-prompt"
  },
  "/articles/how-do-i-track-conversions-across-multiple-marketing-channels": {
    "en": "/blog/how-do-i-track-conversions-across-multiple-marketing-channels",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-long-should-i-run-an-ab-test": {
    "en": "/blog/how-long-should-i-run-an-ab-test",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-ab-test-landing-pages-effectively": {
    "en": "/blog/how-to-ab-test-landing-pages-effectively",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-add-analytics-to-vibe-coded-app": {
    "en": "/blog/how-to-add-analytics-to-vibe-coded-app",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-ajouter-des-analytics-a-une-app-creee-en-vibe-coding"
  },
  "/articles/how-to-analyze-referral-sources-by-utm-tags": {
    "en": "/blog/how-to-analyze-referral-sources-by-utm-tags",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-analyser-les-sources-de-trafic-avec-des-balises-utm"
  },
  "/articles/how-to-attribute-sales-to-ab-test-variants": {
    "en": "/blog/how-to-attribute-sales-to-ab-test-variants",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-build-a-minimum-viable-marketing-analytics-stack": {
    "en": "/blog/how-to-build-a-minimum-viable-marketing-analytics-stack",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-build-lead-nurturing-workflows-in-make": {
    "en": "/blog/how-to-build-lead-nurturing-workflows-in-make",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-build-roi-dashboards-for-marketing-campaigns": {
    "en": "/blog/how-to-build-roi-dashboards-for-marketing-campaigns",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-creer-des-dashboards-roi-pour-tes-campagnes-marketing"
  },
  "/articles/how-to-track-email-campaign-revenue": {
    "en": "/blog/how-to-track-email-campaign-revenue",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-suivre-les-revenus-des-campagnes-emailing"
  },
  "/articles/how-to-track-link-performance-across-multiple-channels": {
    "en": "/blog/how-to-track-link-performance-across-multiple-channels",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-suivre-la-performance-des-liens-sur-plusieurs-canaux"
  },
  "/articles/how-to-track-revenue-per-click": {
    "en": "/blog/how-to-track-revenue-per-click",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-suivre-le-revenu-par-clic"
  },
  "/articles/how-to-track-stripe-payment-link-conversions": {
    "en": "/blog/how-to-track-stripe-payment-link-conversions",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/how-to-track-stripe-sales-and-subscriptions-with-utm-links-without-writing-code": {
    "en": "/blog/how-to-track-stripe-sales-and-subscriptions-with-utm-links-without-writing-code",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-suivre-les-ventes-stripe-avec-des-liens-utm-sans-ecrire-de-code"
  },
  "/articles/how-utm-parameters-impact-conversion-paths": {
    "en": "/blog/how-utm-parameters-impact-conversion-paths",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/comment-les-parametres-utm-influencent-les-parcours-de-conversion"
  },
  "/articles/is-bitly-good-for-conversion-tracking": {
    "en": "/blog/is-bitly-good-for-conversion-tracking",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/est-ce-que-bitly-est-adapte-au-suivi-des-conversions"
  },
  "/articles/link-rotation-ab-testing-landing-pages": {
    "en": "/blog/link-rotation-ab-testing-landing-pages",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/linktree-vs-pimms-comparison-2026": {
    "en": "/blog/linktree-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/measure-click-performance-and-track-link-conversions-easily": {
    "en": "/blog/measure-click-performance-and-track-link-conversions-easily",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/minimum-viable-analytics-the-ideal-tracking-stack-for-your-mvp": {
    "en": "/blog/minimum-viable-analytics-the-ideal-tracking-stack-for-your-mvp",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/multi-touch-attribution-models-complete-comparison-2026": {
    "en": "/blog/multi-touch-attribution-models-complete-comparison-2026",
    "lastmod": "2026-02-21T00:00:00.000Z"
  },
  "/articles/no-code-analytics-guide-for-saas": {
    "en": "/blog/no-code-analytics-guide-for-saas",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/pixelme-vs-pimms-comparison-2026": {
    "en": "/blog/pixelme-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/pretty-links-vs-pimms-comparison-2026": {
    "en": "/blog/pretty-links-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/prompt-first-development-how-to-set-up-attribution-with-one-prompt": {
    "en": "/blog/prompt-first-development-how-to-set-up-attribution-with-one-prompt",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/qr-code-tracking-attribution-marketing": {
    "en": "/blog/qr-code-tracking-attribution-marketing",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/rebrandly-alternatives-comparison-2025": {
    "en": "/blog/rebrandly-alternatives-comparison-2025",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/referrer-vs-utm-vs-fingerprinting-what-really-tells-you-where-a-click-came-from": {
    "en": "/blog/referrer-vs-utm-vs-fingerprinting-where-a-click-came-from",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/referrer-vs-utm-vs-fingerprinting-ou-vient-un-clic"
  },
  "/articles/replug-vs-pimms-comparison-2026": {
    "en": "/blog/replug-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/set-up-analytics-and-marketing-attribution-in-1-hour-for-your-mvp": {
    "en": "/blog/set-up-analytics-and-marketing-attribution-in-1-hour-for-your-mvp",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/short-io-vs-pimms-comparison-2026": {
    "en": "/blog/short-io-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/sniply-vs-pimms-comparison-2026": {
    "en": "/blog/sniply-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/switchy-vs-pimms-comparison-2026": {
    "en": "/blog/switchy-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/taapit-vs-pimms-comparison-2026": {
    "en": "/blog/taapit-vs-pimms-comparison-2026",
    "lastmod": "2026-02-21T00:00:00.000Z",
    "fr": "/blog/taapit-vs-pimms-comparison-2026"
  },
  "/articles/the-best-way-to-get-utm-parameters-into-stripe": {
    "en": "/blog/the-best-way-to-get-utm-parameters-into-stripe",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/the-complete-guide-to-marketing-attribution-for-saas-founders": {
    "en": "/blog/the-complete-guide-to-marketing-attribution-for-saas-founders",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/tinyurl-vs-pimms-comparison-2026": {
    "en": "/blog/tinyurl-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/tly-vs-pimms-comparison-2026": {
    "en": "/blog/tly-vs-pimms-comparison-2026",
    "lastmod": "2026-02-19T00:00:00.000Z"
  },
  "/articles/top-10-marketing-attribution-tools-you-need-in-2025": {
    "en": "/blog/top-10-marketing-attribution-tools-you-need-in-2025",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/top-5-tools-for-funnel-behavior-tracking": {
    "en": "/blog/top-5-tools-for-funnel-behavior-tracking",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/top-5-outils-pour-suivre-le-comportement-dans-les-funnels"
  },
  "/articles/top-7-attribution-tools-for-startups-no-code-and-dev-friendly": {
    "en": "/blog/top-7-attribution-tools-for-startups-no-code-and-dev-friendly",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/top-7-outils-dattribution-pour-startups-no-code-et-adapte-aux-devs"
  },
  "/articles/track-conversions-from-webflow-tally-or-typeform-in-under-3-minutes": {
    "en": "/blog/track-conversions-from-webflow-tally-or-typeform-in-under-3-minutes",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/track-marketing-roi-campaign-cost-attribution": {
    "en": "/blog/track-marketing-roi-campaign-cost-attribution",
    "lastmod": "2026-02-22T00:00:00.000Z"
  },
  "/articles/track-stripe-payments-with-utm-parameters": {
    "en": "/blog/track-stripe-payments-with-utm-parameters",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/ultimate-guide-to-cross-channel-automation-with-make": {
    "en": "/blog/ultimate-guide-to-cross-channel-automation-with-make",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/ultimate-guide-to-no-code-deep-linking": {
    "en": "/blog/ultimate-guide-to-no-code-deep-linking",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/unlock-systemeio-attribution-with-pimms": {
    "en": "/blog/unlock-systemeio-attribution-with-pimms",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/blog/marketing-attribution-ventes-et-leads-avec-systemeio"
  },
  "/articles/utm-and-deep-linking-how-to-easily-unify-web-and-mobile-attribution": {
    "en": "/blog/utm-and-deep-linking-how-to-easily-unify-web-and-mobile-attribution",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/utm-generator-vs-manual-tagging": {
    "en": "/blog/utm-generator-vs-manual-tagging",
    "lastmod": "2026-01-19T00:00:00.000Z"
  },
  "/articles/utm-tagging-system-that-scales-2026": {
    "en": "/blog/utm-tagging-system-that-scales-2026",
    "lastmod": "2026-01-19T00:00:00.000Z"
  },
  "/articles/utm-tracking-for-email-marketing-campaigns": {
    "en": "/blog/utm-tracking-for-email-marketing-campaigns",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/utm-tracking-for-organic-social-media-posts": {
    "en": "/blog/utm-tracking-for-organic-social-media-posts",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/utm-tracking-for-paid-ads-google-meta-linkedin": {
    "en": "/blog/utm-tracking-for-paid-ads-google-meta-linkedin",
    "lastmod": "2026-02-23T00:00:00.000Z"
  },
  "/articles/utm-tracking-for-social-media-campaigns-in-make": {
    "en": "/blog/utm-tracking-for-social-media-campaigns-in-make",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/utm-tracking-for-social-media-segments": {
    "en": "/blog/utm-tracking-for-social-media-segments",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/vibe-coding-meets-analytics-how-to-instrument-your-ai-generated-app-with-no-effort": {
    "en": "/blog/vibe-coding-meets-analytics-how-to-instrument-your-ai-generated-app-with-no-effort",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/what-are-the-best-marketing-attribution-tools-for-startups": {
    "en": "/blog/what-are-the-best-marketing-attribution-tools-for-startups",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/what-is-marketing-attribution-a-beginners-guide": {
    "en": "/blog/what-is-marketing-attribution-a-beginners-guide",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/what-tools-should-i-use-to-track-users-and-conversions-in-my-mvp": {
    "en": "/blog/what-tools-should-i-use-to-track-users-and-conversions-in-my-mvp",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/whats-the-best-way-to-track-stripe-sales-and-subscriptions": {
    "en": "/blog/whats-the-best-way-to-track-stripe-sales-and-subscriptions",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/whats-the-difference-between-a-short-link-and-a-smart-link": {
    "en": "/blog/whats-the-difference-between-a-short-link-and-a-smart-link",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/whats-the-easiest-way-to-set-up-link-tracking-with-attribution": {
    "en": "/blog/whats-the-easiest-way-to-set-up-link-tracking-with-attribution",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/which-ai-tools-can-help-you-launch-a-saas": {
    "en": "/blog/which-ai-tools-can-help-you-launch-a-saas",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/why-link-in-bio-is-becoming-a-mini-sales-funnel": {
    "en": "/blog/why-link-in-bio-is-becoming-a-mini-sales-funnel",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/cal-com-framer-integration-complete-setup-guide": {
    "en": "/guides/cal-com-framer-integration-complete-setup-guide",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/cal-com-framer-integration-complete-setup-guide"
  },
  "/articles/cal-com-webflow-integration-complete-setup-guide": {
    "en": "/guides/cal-com-webflow-integration-complete-setup-guide",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/cal-com-webflow-integration-complete-setup-guide"
  },
  "/articles/calcom-direct-webhook-integration": {
    "en": "/guides/calcom-direct-webhook-integration",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/calcom-direct-webhook-integration"
  },
  "/articles/how-to-track-brevo-forms-and-meetings": {
    "en": "/guides/how-to-track-brevo-forms-and-meetings-webhook-integration",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-brevo-forms-and-meetings-webhook-integration"
  },
  "/articles/how-to-track-calendly": {
    "en": "/guides/how-to-track-calendly-bookings-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-calendly-bookings-marketing-attribution"
  },
  "/articles/how-to-track-carrd": {
    "en": "/guides/how-to-track-carrd-conversions-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-carrd-conversions-marketing-attribution"
  },
  "/articles/how-to-track-elementor-form-leads": {
    "en": "/guides/how-to-track-elementor-form-leads-conversion-tracking",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-elementor-form-leads-conversion-tracking"
  },
  "/articles/how-to-track-framer": {
    "en": "/guides/how-to-track-framer-form-submissions-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-framer-form-submissions-marketing-attribution"
  },
  "/articles/how-to-track-jotform": {
    "en": "/guides/how-to-track-jotform-form-submissions-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-jotform-form-submissions-marketing-attribution"
  },
  "/articles/how-to-track-podia-stripe-payments": {
    "en": "/guides/how-to-track-podia-stripe-payments",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-podia-stripe-payments"
  },
  "/articles/how-to-track-sales-with-stripe-checkout": {
    "en": "/guides/track-stripe-checkout-conversions-with-pimms",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/guides/suivre-conversions-stripe-checkout-avec-pimms"
  },
  "/articles/how-to-track-systemeio-sales-and-leads": {
    "en": "/guides/how-to-track-systemeio-sales-and-leads-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-systemeio-sales-and-leads-marketing-attribution"
  },
  "/articles/how-to-track-tally-webhook": {
    "en": "/guides/tally-direct-webhook-integration",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/tally-direct-webhook-integration"
  },
  "/articles/how-to-track-tally": {
    "en": "/guides/how-to-track-tally-form-submissions-marketing-attribution",
    "lastmod": "2026-01-19T00:00:00.000Z",
    "fr": "/guides/comment-suivre-formulaires-tally-attribution-marketing"
  },
  "/articles/how-to-track-typeform": {
    "en": "/guides/how-to-track-typeform-form-submissions-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-typeform-form-submissions-marketing-attribution"
  },
  "/articles/how-to-track-webflow-leads": {
    "en": "/guides/how-to-track-webflow-form-submissions-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-webflow-form-submissions-marketing-attribution"
  },
  "/articles/introducing-conversion": {
    "en": "/guides/step-by-step-guide-for-developers-to-set-conversion-tracking",
    "lastmod": "2026-01-19T00:00:00.000Z",
    "fr": "/guides/guide-developpeur-tracking-conversions"
  },
  "/articles/no-code-guide-for-website": {
    "en": "/guides/how-to-track-conversions-on-vibe-coding-ai-no-code-sites",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-conversions-on-vibe-coding-ai-no-code-sites"
  },
  "/articles/pimms-analytics-script-complete-guide": {
    "en": "/guides/pimms-analytics-script-complete-reference",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/guides/guide-complet-script-analytics-pimms"
  },
  "/articles/setup-stripe-for-website": {
    "en": "/guides/how-to-track-stripe-sales-marketing-attribution",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/guides/how-to-track-stripe-sales-marketing-attribution"
  },
  "/articles/start-with-cal-com-and-zapier": {
    "en": "/guides/how-to-track-cal-com-bookings-marketing-attribution",
    "lastmod": "2026-01-19T00:00:00.000Z",
    "fr": "/guides/comment-suivre-reservations-cal-com-attribution-marketing"
  },
  "/articles/start-with-iclosed-and-zapier": {
    "en": "/guides/how-to-track-iclosed-bookings-marketing-attribution",
    "lastmod": "2026-01-19T00:00:00.000Z",
    "fr": "/guides/comment-suivre-reservations-iclosed-attribution-marketing"
  },
  "/articles/start-with-zapier": {
    "en": "/tutorials/how-to-track-conversions-with-zapier-and-pimms",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/tutoriels/comment-tracker-les-conversions-avec-zapier-attribution-marketing"
  },
  "/articles/utm-guide": {
    "en": "/tutorials/mastering-utm-tracking-with-deep-linking",
    "lastmod": "2025-09-14T00:00:00.000Z",
    "fr": "/tutoriels/maitriser-le-tracking-utm-et-le-deep-linking"
  },
  "/articles/abuse": {
    "en": "/legal/report-abuse",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/imprint": {
    "en": "/legal/imprint",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/privacy": {
    "en": "/legal/privacy-policy",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/articles/terms": {
    "en": "/legal/terms-of-service",
    "lastmod": "2025-09-14T00:00:00.000Z"
  },
  "/landings/2octobre": {
    "en": "/2october",
    "lastmod": "2025-10-02T00:00:00.000Z",
    "fr": "/2octobre"
  },
  "/landings/analytics": {
    "en": "/products/analytics-attribution-track-clicks-leads-revenue",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/products/analytics-attribution-track-clicks-leads-revenue"
  },
  "/landings/brevo": {
    "en": "/integrations/brevo-email-marketing-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-brevo-email-marketing"
  },
  "/landings/bulk-links": {
    "en": "/products/bulk-link-management-folders-csv-import",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/products/bulk-link-management-folders-csv-import"
  },
  "/landings/calcom": {
    "en": "/integrations/calcom-booking-conversion-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-calcom-reservations-conversions"
  },
  "/landings/calendly": {
    "en": "/integrations/calendly-booking-conversion-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-calendly-reservations-conversions"
  },
  "/landings/contact-sales": {
    "en": "/contact-sales",
    "lastmod": "2026-02-20T00:00:00.000Z",
    "fr": "/contact-sales"
  },
  "/landings/elementor": {
    "en": "/integrations/elementor-form-lead-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-elementor-formulaires-leads"
  },
  "/landings/for-agencies": {
    "en": "/solutions/pimms-for-marketing-agencies",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/solutions/pimms-pour-agences-marketing"
  },
  "/landings/for-freelancers": {
    "en": "/solutions/pimms-for-freelancers-solopreneurs",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/solutions/pimms-pour-independants-solopreneurs"
  },
  "/landings/framer": {
    "en": "/integrations/framer-website-conversion-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-framer-conversions-site"
  },
  "/landings/home": {
    "en": "/",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/"
  },
  "/landings/iclosed": {
    "en": "/integrations/iclosed-sales-meeting-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-iclosed-meetings-ventes"
  },
  "/landings/integrations": {
    "en": "/products/integrations-connect-your-tools",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/products/integrations-connect-your-tools"
  },
  "/landings/landing-page-tracking": {
    "en": "/solutions/conversion-tracking-landing-page-analytics",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/solutions/suivi-conversions-analytics-landing-page"
  },
  "/landings/linkedin-tracker": {
    "en": "/solutions/linkedin-analytics-profile-visitor-tracking",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/solutions/analytics-profil-linkedin-visiteurs"
  },
  "/landings/podia": {
    "en": "/integrations/podia-course-sales-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-podia-ventes-cours"
  },
  "/landings/pricing": {
    "en": "/pricing",
    "lastmod": "2026-02-20T00:00:00.000Z",
    "fr": "/pricing"
  },
  "/landings/qr-codes": {
    "en": "/products/dynamic-qr-codes-tracking-marketing",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/products/dynamic-qr-codes-tracking-marketing"
  },
  "/landings/shopify": {
    "en": "/solutions/shopify-ecommerce-sales-tracking",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/solutions/shopify-ecommerce-sales-tracking"
  },
  "/landings/smart-links": {
    "en": "/products/smart-links-branded-short-links-deep-links-qr-codes",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/products/smart-links-branded-short-links-deep-links-qr-codes"
  },
  "/landings/stripe": {
    "en": "/solutions/stripe-payment-revenue-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/solutions/tracking-stripe-paiements-revenus"
  },
  "/landings/systemeio": {
    "en": "/integrations/systemeio-funnel-tracking-sales",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/integrations/tracking-systemeio-funnel-ventes"
  },
  "/landings/tally": {
    "en": "/integrations/tally-form-conversion-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-tally-formulaires-conversions"
  },
  "/landings/tracking": {
    "en": "/solutions/marketing-tracking-attribution-clicks-leads-revenue",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/solutions/marketing-tracking-attribution-clics-leads-revenus"
  },
  "/landings/utm": {
    "en": "/solutions/get-rid-of-google-sheets-for-your-utms",
    "lastmod": "2026-03-09T00:00:00.000Z",
    "fr": "/solutions/remplace-google-sheets-pour-tes-utms"
  },
  "/landings/webflow": {
    "en": "/integrations/webflow-form-lead-tracking",
    "lastmod": "2026-02-19T00:00:00.000Z",
    "fr": "/integrations/tracking-webflow-formulaires-leads"
  },
  "/landings/youtube": {
    "en": "/solutions/deep-links-youtube-channel",
    "lastmod": "2025-10-06T00:00:00.000Z",
    "fr": "/solutions/deep-links-chaine-youtube"
  }
} as const;
